HeaderNavCtrl.$inject = ['$scope', '$location', '$window', 'CurrentUser', 'AnalyticsServ'];

export default function HeaderNavCtrl($scope, $location, $window, CurrentUser, AnalyticsServ) {
  $scope.actions = {
    signup: {
      text: 'Sign Up',
      link: '/signup',
      visible: false
    },
    signin: {
      text: 'Sign In',
      link: '/signin',
      visible: false
    }
  };
  $scope.signout = () => {
    CurrentUser.api.signout();
  }

  $scope.navHome = () => {
    if (CurrentUser.data.id && CurrentUser.data.email) {
      $location.path('/home');
    } else {
      $window.location.href = '/';
    }
    AnalyticsServ.clicked('Home Icon', {
      'Authenticated': !!CurrentUser.data.id
    })
  }

  $scope.setActions = function (actions) {
    var action;
    if (actions && actions.length > 0) {
      for (var i = 0; i < actions.length; i++) {
        action = actions[i];
        if (action && $scope.actions[action]) {

          $scope.actions[action].visible = true;
        }
      }
    }
  };
};



// WEBPACK FOOTER //
// ./project/directives/header-nav/header-nav.controller.js